import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    aiComparisonFieldsList: [],
    aiComparisonFieldsRecord: [],
    aiComparisonFieldsDropdownList: [],
    aiComparisonData: {},
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const AIComparisonFieldsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AI_COMPARISON_FIELDS_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.AI_COMPARISON_FIELDS_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
                aiComparisonFieldsRecord: [],
            }    
        case actionTypes.AI_COMPARISON_FIELDS_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                aiComparisonFieldsList: action.aiComparisonFieldsList,
                showUpdateForm: false,
                showViewPage: false,
                aiComparisonFieldsRecord: [],
            }
        case actionTypes.AI_COMPARISON_FIELDS_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                aiComparisonFieldsRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes.AI_COMPARISON_FIELDS_DROPDOWN_SUCCESS:
            return {
                ...state,
                Loading: false,
                aiComparisonFieldsDropdownList: action.aiComparisonFieldsDropdownList,
            }  
        case actionTypes.AI_COMPARISON_FIELDS_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_AI_COMPARISON_FIELDS_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes.REDIRECT_TO_AI_COMPARISON_FIELDS_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: '',
                aiComparisonFieldsRecord: [],
            }
        case actionTypes.AI_COMPARISON_DATA_SUCCESS:
            return {
                ...state,
                Loading: false,
                aiComparisonData: action.aiComparisonData,
            }
        default:
            return state;
    }
}

export default AIComparisonFieldsReducer;